<template>
  <div class="gerenciar-cartoes container-fluid">
    <div class="row mt-2">
      <span
        v-if="objCartoes.length == 0"
        class="d-flex justify-content-center text-center px-5 mt-4"
        >Você não possui nenhum cartão cadastrado.</span
      >
      <section class="col flex-column p-4">
        <CardCreditCardItem
          :itens="objCartoes"
          @loadCartoes="loadCartoes"
        ></CardCreditCardItem>
      </section>
      <Success :dados="sucesso"></Success>
    </div>
  </div>
</template>
<script>
import CardCreditCardItem from "@/components/carteira-digital/cartao/CardCreditCardItem.vue";
import Success from "@/components/Success.vue";
import { ApiCartoesService } from "@/service/carteira-digital/ApiCartoesService.js";
const cartoesService = new ApiCartoesService();

export default {
  name: "GerenciarCartoes",
  components: {
    CardCreditCardItem,
    Success,
  },
  data() {
    return {
      objItem: Object,
      objCartoes: [],
      token: "",
      sucesso: {
        type: "NONE",
      },
    };
  },
  mounted() {
    this.loadCartoes();
  },

  methods: {
    loadCartoes() {
      this.sucesso.type = "AGUARDE";
      this.sucesso.mensagem = "Aguarde, estamos processando sua solicitação";
      cartoesService
        .getListaCartoesCompra()
        .then((res) => {
          this.objCartoes = res;
          this.sucesso.type = "NONE";
        })
        .catch((error) => {
          this.sucesso.type = "ERRO";
          this.sucesso.mensagem = error.response
            ? error.response.data.title
            : "Serviço indisponível.";
          this.flCadastrarEndereco = true;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.gerenciar-cartoes {
  background-color: #f2f2f2;
}
</style>
